import { createAppRequest } from '@/services/request';
import type { ApiRequestOptions } from './types/common';
import type {
  FamsAiAssistantChatPayload,
  FamsAiAssistantResponse,
  FamsAiActionDraft,
  FamsAiActionDraftList,
  FamsAiActionProposal,
} from './types/ai-assistant';

const request = createAppRequest();

export async function chatWithFamsAiAssistant(
  data: FamsAiAssistantChatPayload,
  options?: ApiRequestOptions,
) {
  return request<FamsAiAssistantResponse>('/bff/fams/ai-assistant/chat', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function getFamsAiActionDrafts(
  params?: { status?: string; actionType?: string; current?: number; pageSize?: number },
  options?: ApiRequestOptions,
) {
  return request<FamsAiActionDraftList>('/bff/fams/ai-assistant/actions', {
    method: 'GET',
    params,
    ...(options || {}),
  });
}

export async function createFamsAiActionDraft(
  data: FamsAiActionProposal,
  options?: ApiRequestOptions,
) {
  return request<FamsAiActionDraft>('/bff/fams/ai-assistant/actions', {
    method: 'POST',
    data,
    ...(options || {}),
  });
}

export async function updateFamsAiActionDraft(
  uuid: string,
  data: Partial<Pick<FamsAiActionDraft, 'title' | 'description' | 'owner' | 'dueDate' | 'priority'>>,
  options?: ApiRequestOptions,
) {
  return request<FamsAiActionDraft>(`/bff/fams/ai-assistant/actions/${uuid}`, {
    method: 'PATCH',
    data,
    ...(options || {}),
  });
}

export async function confirmFamsAiActionDraft(uuid: string, options?: ApiRequestOptions) {
  return request<{ action: FamsAiActionDraft; result: Record<string, unknown> }>(
    `/bff/fams/ai-assistant/actions/${uuid}/confirm`,
    { method: 'POST', ...(options || {}) },
  );
}

export async function rejectFamsAiActionDraft(uuid: string, options?: ApiRequestOptions) {
  return request<FamsAiActionDraft>(`/bff/fams/ai-assistant/actions/${uuid}/reject`, {
    method: 'POST',
    ...(options || {}),
  });
}

export async function completeFamsAiActionDraft(uuid: string, options?: ApiRequestOptions) {
  return request<FamsAiActionDraft>(`/bff/fams/ai-assistant/actions/${uuid}/complete`, {
    method: 'POST',
    ...(options || {}),
  });
}
